import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-title"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 10,
  class: "toggle"
}
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 11,
  class: "uploader"
}
const _hoisted_8 = {
  key: 0,
  class: "option-description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BuilderInputs = _resolveComponent("BuilderInputs", true)
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_GenrateTextarea = _resolveComponent("GenrateTextarea")
  const _component_Input = _resolveComponent("Input")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Checkgroup = _resolveComponent("Checkgroup")
  const _component_UrlsList = _resolveComponent("UrlsList")
  const _component_Switch = _resolveComponent("Switch")
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_Uploader = _resolveComponent("Uploader")
  const _component_LinkSaver = _resolveComponent("LinkSaver")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["builder-inputs", {row: $props.row}])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.opts, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.value,
        class: _normalizeClass(["field", item.type !== 'container' && $options.classnames(item)]),
        style: _normalizeStyle($options.fieldStyles(item, idx))
      }, [
        (item.type === 'container')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (item.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_BuilderInputs, {
                "vread-from": "valid",
                "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                class: _normalizeClass($options.classnames(item)),
                gap: item.gap,
                opts: item.opts,
                propstore: $props.propstore,
                row: item.dir === 'row',
                onUpdate: $options.onUpdate
              }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                _renderList(Object.keys(_ctx.$slots), (slot) => {
                  return {
                    name: slot,
                    fn: _withCtx((data) => [
                      _renderSlot(_ctx.$slots, slot, _mergeProps({ ref_for: true }, data), undefined, true)
                    ])
                  }
                })
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["onUpdate:valid", "class", "gap", "opts", "propstore", "row", "onUpdate"])
            ], 64 /* STABLE_FRAGMENT */))
          : (item.type === 'tabs')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_Tabs, {
                  modelValue: $options.my_store[item.field],
                  "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                  tabs: item.opts,
                  onTabChange: $event => ($options.onTabChange(item.field, idx))
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "tabs", "onTabChange"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.opts, (tab, tab_idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: tab_idx }, [
                    (tab.value === $options.my_store[item.field])
                      ? (_openBlock(), _createBlock(_component_BuilderInputs, {
                          key: 0,
                          ref_for: true,
                          ref: 'tab_inputs_' + idx,
                          "vread-from": "valid",
                          "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                          opts: tab.opts,
                          propstore: $props.propstore,
                          onUpdate: $options.onUpdate
                        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                          _renderList(Object.keys(_ctx.$slots), (slot) => {
                            return {
                              name: slot,
                              fn: _withCtx((data) => [
                                _renderSlot(_ctx.$slots, slot, _mergeProps({ ref_for: true }, data), undefined, true)
                              ])
                            }
                          })
                        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["onUpdate:valid", "opts", "propstore", "onUpdate"]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (item.title)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      disabled: item.disabled
                    }, _toDisplayString(item.title), 9 /* TEXT, PROPS */, _hoisted_2))
                  : _createCommentVNode("v-if", true),
                (item.description)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      disabled: item.disabled,
                      class: "description"
                    }, _toDisplayString(item.description), 9 /* TEXT, PROPS */, _hoisted_3))
                  : _createCommentVNode("v-if", true),
                (['text', 'url', 'email', 'number', 'identifier', 'command'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_Input, {
                      key: item.field,
                      modelValue: $options.my_store[item.field],
                      "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                      "vread-from": "valid",
                      "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                      disabled: item.disabled,
                      type: item.type,
                      placeholder: item.placeholder,
                      description: item.description,
                      spellcheck: item.spellcheck ?? true,
                      button: item.can_generate ? 'stars-02' : '',
                      "button-color": 'var(--brand-600)',
                      minlength: item.minlength,
                      maxlength: item.maxlength,
                      min: item.min,
                      max: item.max,
                      step: item.step,
                      required: item.required,
                      "post-flush": item.post_flush,
                      validator: item.validator,
                      onBlur: $event => ($options.onUpdate(item.field))
                    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                      (item.genrate_url)
                        ? {
                            name: "custom_icon",
                            fn: _withCtx(() => [
                              _createVNode(_component_GenrateTextarea, {
                                title: item.title,
                                maxlength: item.maxlength,
                                rows: 3,
                                "api-url": item.genrate_url,
                                "api-args": () => item.genrate_args($options.my_store),
                                can_genrate: true,
                                can_add: ($options.my_store[item.field] || '' ).length < item.maxlength,
                                onAppend: (value) => $options.onTextAppend(item, value),
                                onReplace: (value) => $options.onTextReplace(item, value)
                              }, null, 8 /* PROPS */, ["title", "maxlength", "api-url", "api-args", "can_add", "onAppend", "onReplace"])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "disabled", "type", "placeholder", "description", "spellcheck", "button", "minlength", "maxlength", "min", "max", "step", "required", "post-flush", "validator", "onBlur"]))
                  : (item.type === 'dropdown')
                    ? (_openBlock(), _createBlock(_component_Dropdown, {
                        key: 3,
                        modelValue: $options.my_store[item.field],
                        "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                        "vread-from": "valid",
                        "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                        items: typeof item.items === 'string' ? $options.my_store[item.items] : item.items,
                        disabled: item.disabled,
                        description: item.description,
                        placeholder: item.placeholder,
                        required: item.required,
                        small: item.small,
                        onChange: $event => ($options.onUpdate(item.field))
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "items", "disabled", "description", "placeholder", "required", "small", "onChange"]))
                    : (item.type === 'multiselect')
                      ? (_openBlock(), _createBlock(_component_Multiselect, {
                          key: 4,
                          modelValue: $options.my_store[item.field],
                          "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                          "vread-from": "valid",
                          "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                          items: typeof item.items === 'string' ? $options.my_store[item.items] : item.items,
                          disabled: item.disabled,
                          required: item.required,
                          placeholder: item.placeholder,
                          small: item.small,
                          onChange: $event => ($options.onUpdate(item.field))
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "items", "disabled", "required", "placeholder", "small", "onChange"]))
                      : (['textarea', 'textarea-json', 'textarea-kb'].includes(item.type))
                        ? (_openBlock(), _createBlock(_component_TextArea, {
                            key: 5,
                            modelValue: $options.my_store[item.field],
                            "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                            "vread-from": "valid",
                            "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                            footer: item.footer,
                            counter: item.counter,
                            placeholder: item.placeholder,
                            maxlength: item.maxlength,
                            minlength: item.minlength,
                            min_width: item.min_width,
                            spellcheck: item.spellcheck,
                            rows: item.rows || 5,
                            type: item.type,
                            class: "textarea",
                            required: item.required,
                            error: item.error,
                            validator: item.validator,
                            onBlur: $event => ($options.onUpdate(item.field))
                          }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                            (item.genrate_url)
                              ? {
                                  name: "custom_icon",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_GenrateTextarea, {
                                      title: item.title,
                                      maxlength: item.maxlength,
                                      rows: (item.rows || 5) + 2,
                                      "api-url": item.genrate_url,
                                      "api-args": () => item.genrate_args($options.my_store),
                                      can_genrate: true,
                                      can_add: ($options.my_store[item.field] || '').length < item.maxlength,
                                      onAppend: (value) => $options.onTextAppend(item, value),
                                      onReplace: (value) => $options.onTextReplace(item, value)
                                    }, null, 8 /* PROPS */, ["title", "maxlength", "rows", "api-url", "api-args", "can_add", "onAppend", "onReplace"])
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "footer", "counter", "placeholder", "maxlength", "minlength", "min_width", "spellcheck", "rows", "type", "required", "error", "validator", "onBlur"]))
                        : (item.type === 'checkbox')
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 6,
                              modelValue: $options.my_store[item.field],
                              "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                              onChange: $event => ($options.onUpdate(item.field))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "onChange"]))
                          : (item.type === 'checkgroup')
                            ? (_openBlock(), _createBlock(_component_Checkgroup, {
                                key: 7,
                                modelValue: $options.my_store[item.field],
                                "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                items: item.items,
                                rows: "4",
                                onChange: $event => ($options.onUpdate(item.field))
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "items", "onChange"]))
                            : (item.type === 'urls-list')
                              ? (_openBlock(), _createBlock(_component_UrlsList, {
                                  key: 8,
                                  modelValue: $options.my_store[item.field],
                                  "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                  "vread-from": "valid",
                                  "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
                                  title: item.btn_label,
                                  type: item.type,
                                  items_label: item.title,
                                  max: item.max,
                                  onBlur: $event => ($options.onUpdate(item.field))
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "title", "type", "items_label", "max", "onBlur"]))
                              : (item.type === 'switch')
                                ? (_openBlock(), _createBlock(_component_Switch, {
                                    key: 9,
                                    modelValue: $options.my_store[item.field],
                                    "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                    class: "switch-item",
                                    label: item.label,
                                    description: item.description,
                                    onChange: $event => ($options.onUpdate(item.field))
                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "description", "onChange"]))
                                : (item.type === 'toggle')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_Toggle, {
                                        modelValue: $options.my_store[item.field],
                                        "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                        onChange: $event => ($options.onUpdate(item.field))
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                      _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", null, _toDisplayString(item.label), 1 /* TEXT */),
                                        (item.sublabel)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.sublabel), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ]))
                                  : (item.type === 'uploader')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createCommentVNode(" Avatar uploader "),
                                        (item.mode === 'avatar')
                                          ? (_openBlock(), _createBlock(_component_Uploader, {
                                              key: 0,
                                              mode: item.mode,
                                              label: item.title,
                                              description: item.description,
                                              "max-uploads": 1,
                                              "max-size": $data.AVATAR.max_size,
                                              accept: $data.AVATAR.accept,
                                              "store-type": $data.AVATAR.type,
                                              "store-tag": $options.my_store.id,
                                              onUploaded: file => $options.onAvatarUploaded(item, file),
                                              onRemoved: () => $options.onAvatarRemoved(item)
                                            }, null, 8 /* PROPS */, ["mode", "label", "description", "max-size", "accept", "store-type", "store-tag", "onUploaded", "onRemoved"]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createCommentVNode(" all other files upload "),
                                              _createVNode(_component_Uploader, {
                                                mode: item.mode,
                                                label: item.title,
                                                description: item.description,
                                                accept: item.accept,
                                                "max-uploads": item.max_uploads,
                                                "max-size": item.max_size,
                                                "store-type": item.file_type,
                                                "store-tag": $options.my_store.id,
                                                "txt-rows": item.rows,
                                                "file-rows": item.file_rows
                                              }, null, 8 /* PROPS */, ["mode", "label", "description", "accept", "max-uploads", "max-size", "store-type", "store-tag", "txt-rows", "file-rows"])
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      ]))
                                    : (item.type === 'link-saver')
                                      ? (_openBlock(), _createBlock(_component_LinkSaver, {
                                          key: 12,
                                          modelValue: $options.my_store[item.field],
                                          "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                          "max-length": item.max_length,
                                          onChange: $event => ($options.onUpdate(item.field))
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "max-length", "onChange"]))
                                      : (item.type === 'button-group')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                            _createVNode(_component_ButtonGroup, {
                                              modelValue: $options.my_store[item.field],
                                              "onUpdate:modelValue": $event => (($options.my_store[item.field]) = $event),
                                              options: item.opts,
                                              onChange: $event => ($options.onUpdate(item.field))
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "onChange"]),
                                            ($options.optionDescription(item))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($options.optionDescription(item)), 1 /* TEXT */))
                                              : _createCommentVNode("v-if", true)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 14 }, _renderList(Object.keys(_ctx.$slots), (slot) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: slot }, [
                                              (item.type === slot)
                                                ? _renderSlot(_ctx.$slots, slot, {
                                                    key: 0,
                                                    item: item,
                                                    onUpdate: $options.onUpdate,
                                                    store: $options.my_store
                                                  }, undefined, true)
                                                : _createCommentVNode("v-if", true)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
      ], 6 /* CLASS, STYLE */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}